import React from 'react'
import { FormHelperText, Checkbox } from '@material-ui/core'

function CheckboxInput({
  input,
  label,
  disabled,
  required,
  inputProps,
  onChange,
  children,
  meta: { submitError, touched, error },
}) {
  let errorMessage = null
  let errorStatus = false

  if (touched && (error || submitError)) {
    errorStatus = true
    errorMessage = error || submitError
  }

  return (
    <>
      <Checkbox
        {...input}
        {...inputProps}
        select
        error={errorStatus}
        label={label}
        disabled={disabled}
        required={required}
        onChange={onChange}>
        {children}
      </Checkbox>
      <div className="error">
        {errorStatus && <FormHelperText>{errorMessage}</FormHelperText>}
      </div>
    </>
  )
}

export default CheckboxInput
